module.exports = {
  // Ecommerce Platform
  platform: 'vtex',

  // Platform specific configs for API
  api: {
    storeId: 'decathlonstore',
    workspace: 'cms',
    environment: 'vtexcommercestable',
    hideUnavailableItems: true,
  },

  proxyUrl: {
    store: 'decathlonstore.vtexcommercestable',
  },

  servicesWorkspace: 'master',

  InsuranceID: ['2145845749', '2145846158'],

  // Default channel
  channel: '{"salesChannel":"3"}',
  sc: '3',
  locale: 'pt-BR',

  // Production URLs
  productionUrl: 'https://www.decathlon.com.br',
  storeUrl: 'https://store.decathlon.com.br',
  secureSubdomain: 'https://secure.decathlon.com.br',
  checkoutUrl: 'https://secure.decathlon.com.br/checkout',

  // DEPLOY: apagar `checkoutQueryParams` (ou deixar {}) antes de produção.
  // `buildCheckoutPaymentUrl` anexa estes params em toda ida ao checkout de
  // pagamento, junto com orderFormId / payment_recovery.
  // Não coloque `?` direto no checkoutUrl — isso gera um segundo `?` e quebra a URL
  checkoutQueryParams: {},

  loginUrl: 'https://secure.decathlon.com.br/api/io/login',
  signUpUrl: 'https://secure.decathlon.com.br/cadastro',
  accountUrl: 'https://store.decathlon.com.br/account',
  apiReviewDecathlon:
    'https://decathlonstore.myvtex.com/api/io/_v/graphql/private/v1',
  faststoreApi: 'https://decathlonstore.vtex.app/api',

  // Search URLs
  decathlonSearch: '/_v3/api/decathlon-search',

  // Lighthouse CI
  lighthouse: {
    server: process.env.BASE_SITE_URL || 'http://localhost:9000',
    pages: {
      home: '/',
      plp: '/roupas/roupas-masculinas',
      pdp: '/mochila-de-trilha-10l-arpenaz-50-preta-preto-8551453-quechua/p',
    },
  },

  // E2E CI
  cypress: {
    pages: {
      pages: {
        home: '/',
        pdp: '/meia-termica-cano-alto-adulto-de-ski-e-snowboard-638256727/p',
        collection: '/ciclismo/',
        search: '/pesquisa?q=tenis&sort=score_desc&page=0',
      },
    },
  },

  analytics: {
    // https://developers.google.com/tag-platform/tag-manager/web#standard_web_page_installation
    gtmContainerId: 'GTM-T777CVM',
    gtmContainerId2: 'GTM-W9G828C4',
  },

  token: {
    storeId: 'decathlonstoreapp',
  },

  logRocket: {
    appId: 'izcqja/corebiz-decathlon',
  },

  builder: {
    apiKey: '1a46d27fc8364e2f8b22a0b3b035f833',
  },

  recaptcha: {
    siteKey: '6Lf4bwAsAAAAAH8lTIZ4oNk0fSZAZ6g7Y3k1GGmo',
  },

  releaseVersion:
    process.env.NODE_ENV === 'production' ? '2.38.8' : '2.38.8-dev',

  features: {
    blogSitemap: true,
    cmsPageSitemap: false,
  },
}
